/**
 * msAi 认证配置
 * 使用共享的认证系统
 */
import { createServiceAuthConfig } from '@ms/shared-config';
import { TokenManager } from '@ms/shared-auth';

const baseConfig = createServiceAuthConfig('msAi');

const resolveApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // 如果是 ai.ihoms.cn，使用当前域名作为 API base URL
    if (hostname === 'ai.ihoms.cn') {
      return window.location.origin;
    }

    // 其他 ihoms.cn 子域，使用 www.ihoms.cn（msLogin）
    if (hostname.includes('ihoms.cn')) {
      return 'https://www.ihoms.cn';
    }

    return window.location.origin;
  }

  return (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    baseConfig.apiBaseUrl
  );
};

const resolveMsLoginUrl = () => {
  if (typeof window !== 'undefined') {
    return (
      (window as any).REACT_APP_MSLOGIN_URL ||
      process.env.REACT_APP_MSLOGIN_URL ||
      baseConfig.msLoginUrl
    );
  }

  return (
    process.env.REACT_APP_MSLOGIN_URL ||
    process.env.MSLOGIN_URL ||
    baseConfig.msLoginUrl
  );
};

export const msAiAuthConfig = {
  ...baseConfig,
  apiBaseUrl: resolveApiBaseUrl(),
  msLoginUrl: resolveMsLoginUrl(),
};

// shared-auth 的 useAuth/AuthGuard 通过 window 全局变量定位 msLogin 校验与登录页：
// 未设置时会误用当前域名（ai.ihoms.cn 没有 /api/auth/verify）或跳转不存在的 /login。
if (typeof window !== 'undefined') {
  const w = window as any;
  if (!w.REACT_APP_API_BASE_URL) {
    w.REACT_APP_API_BASE_URL = msAiAuthConfig.msLoginUrl;
  }
  if (!w.REACT_APP_MSLOGIN_LOGIN_URL) {
    // 必须是 /login 页面路径——根路径会把已登录用户导去 /services 服务台
    w.REACT_APP_MSLOGIN_LOGIN_URL = `${msAiAuthConfig.msLoginUrl.replace(/\/+$/, '')}/login`;
  }

  // msLogin 登录成功后用 ?token= 回跳；useAuth 只读 storage，
  // 这里先收割 URL 中的 token 入库，否则回跳后仍判定未登录 → 登录循环
  TokenManager.getCurrentToken();
}

export default msAiAuthConfig;
